import { formatPrice } from "@helpers/formatPrice";
import { formatUsd } from "../Controls/TradeForm/utils/format";

// Display formatters for open trades, shared by the table and the trade modals

export const toNumber = (value) => {
  if (value == null || value === "") return null;
  const numeric = Number(String(value).replace(/,/g, "").trim());
  return Number.isFinite(numeric) ? numeric : null;
};

export const formatWager = (order) => {
  const amount = toNumber(order?.margin);
  if (amount == null) return "—";

  return formatUsd(amount);
};

export const formatDollarPrice = (value) => {
  const numeric = toNumber(value);
  if (numeric == null) return "—";
  return `$${formatPrice(numeric)}`;
};

export const formatSignedPnl = (value) => {
  if (value == null || !Number.isFinite(value)) return "—";

  const abs = Math.abs(value).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (value > 0) return `+$${abs}`;
  if (value < 0) return `-$${abs}`;
  return `$${abs}`;
};

export const formatTpSlAmount = (value) => {
  if (value == null || !Number.isFinite(value)) return null;

  const rounded = Math.round(Math.abs(value) * 100) / 100;
  const text = rounded.toLocaleString("en-US", {
    minimumFractionDigits: Number.isInteger(rounded) ? 0 : 2,
    maximumFractionDigits: 2,
  });

  if (value > 0) return `+${text}$`;
  if (value < 0) return `-${text}$`;
  return `${text}$`;
};

/**
 * "up" for a gain, "down" for a loss, null for zero or no value.
 * @param {number|null|undefined} value
 */
export const getTone = (value) => {
  if (value > 0) return "up";
  if (value < 0) return "down";
  return null;
};

/** "BTCUSDT" → "BTC", the case is kept */
export const stripQuoteAsset = (symbol) =>
  String(symbol ?? "").replace(/(USDT|USDC|BUSD)$/i, "");

export const getTriggerPnl = (triggerPrice, entryPrice, quantity, isSellSide) => {
  const target = toNumber(triggerPrice);
  if (target == null || !entryPrice || !quantity) return null;

  return isSellSide
    ? (entryPrice - target) * quantity
    : (target - entryPrice) * quantity;
};
